import { forwardRef } from 'react';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';

import { cn } from '../../utils/cn';

export const DropdownMenu = DropdownMenuPrimitive.Root;
export const DropdownMenuTrigger = DropdownMenuPrimitive.Trigger;
export const DropdownMenuPortal = DropdownMenuPrimitive.Portal;
export const DropdownMenuGroup = DropdownMenuPrimitive.Group;

export const DropdownMenuContent = forwardRef(function DropdownMenuContent(
  { className, sideOffset = 8, align = 'end', ...props },
  ref,
) {
  return (
    <DropdownMenuPrimitive.Portal>
      <DropdownMenuPrimitive.Content
        ref={ref}
        sideOffset={sideOffset}
        align={align}
        data-ds-id="ds/overlay/dropdown-menu"
        className={cn(
          // eslint-disable-next-line no-restricted-syntax -- dimensões do overlay
          'z-50 max-h-[min(24rem,70vh)] min-w-[240px] overflow-y-auto rounded-ds-lg border border-border bg-card p-space-1 text-foreground shadow-2xl',
          className,
        )}
        {...props}
      />
    </DropdownMenuPrimitive.Portal>
  );
});

export const DropdownMenuItem = forwardRef(function DropdownMenuItem(
  { className, inset, variant = 'default', ...props },
  ref,
) {
  const destructive = variant === 'destructive';
  return (
    <DropdownMenuPrimitive.Item
      ref={ref}
      data-ds-id={
        destructive
          ? 'ds/overlay/dropdown-menu--destructive'
          : 'ds/overlay/dropdown-menu--item'
      }
      className={cn(
        'relative flex cursor-pointer select-none items-start gap-2 rounded-ds-md px-space-3 py-space-2-5 text-type-body-sm outline-none transition-colors',
        destructive
          ? 'text-danger-700 hover:bg-danger-50 dark:hover:bg-danger-500/20 dark:text-danger-500'
          : 'hover:bg-stone-100 focus:bg-stone-100 dark:hover:bg-stone-800 dark:focus:bg-stone-800',
        'data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
        inset && 'pl-8',
        className,
      )}
      {...props}
    />
  );
});

export const DropdownMenuLabel = forwardRef(function DropdownMenuLabel(
  { className, ...props },
  ref,
) {
  return (
    <DropdownMenuPrimitive.Label
      ref={ref}
      className={cn('px-space-3 py-space-1 text-type-label font-semibold text-muted-foreground', className)}
      {...props}
    />
  );
});

export const DropdownMenuSeparator = forwardRef(function DropdownMenuSeparator(
  { className, ...props },
  ref,
) {
  return (
    <DropdownMenuPrimitive.Separator
      ref={ref}
      className={cn('-mx-1 my-1 h-px bg-border', className)}
      {...props}
    />
  );
});
